// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__hr0Br","col":"styles_col__1bcx8","fulfillmentStatus":"styles_fulfillmentStatus__sFvTy","emailCol":"styles_emailCol__11hpG"};